import React, {  useRef, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./ReasonsChoose.css";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faHouse,faRocket,faSliders,faChartBar} from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';
const data = [
  { id: 1, img: <FontAwesomeIcon icon={faHouse} />, title: "Marketplace", para: "Explore a world of trading strategies! A marketplace where you choose and deploy from professionally curated strategies or even sell your own strategy." },
  { id: 2, img: <FontAwesomeIcon icon={faRocket} />, title: "Deployed Strategies", para: " Place orders directly on the broker account using which you logged in. (no additional setup required.) . After entry orders are executed, place stop loss and target orders simultaneously" },
  { id: 3, img: <FontAwesomeIcon icon={faSliders} />, title: "Options Builder", para: " Create directional or non directional strategies with smart indicators and signals. Intraday and positional both. Build multiple cases with different transaction Legs and Entry / Exit signals." },
  { id: 4, img: <FontAwesomeIcon icon={faChartBar} />, title: "Indicator Templates", para: "Candle / Heikin Ashi / Renko, SuperTrend / RSI / ATR / SMA / ... (27 more), Volume / Open interest based signal generation, BullishHammer / BullishEngulfing / BearishMarubozu / BearishSpinningTop" },

];
function ReasonsChoose() {
  const [show, setShow] = useState(false);
  const { isSuccess } = useSelector(
    userSelector
  );
  const childRef = useRef(null);
  const clickToggleLoginPopup = (showhide) => {
    if (isSuccess) {
      window.open(
        'https://www.quantman.in',
        '_blank' // <- This is what makes it open in a new window.
      );
    }
    else {
      childRef.current.changeTogglePopup(showhide);
    }
  }
  return (
    <>
      <section className="quantmanreasons_section">
        <Container>
          <Row>
            <Col md={{ span: 12, offset: 0 }} lg={{ span: 10, offset: 1 }}>
              <h3>4 Reasons to Choose <br></br> <span>Quantman</span></h3>
              <Row>
                {data.map((data, i) => {
                  return (
                    <div className="col-md-6" key={i}>
                      <div className="quantmanreasons_group">
                        <div className="quantmanreasons_panel">
                          <div className="quantmanreasons_imgpanel">
                            <span>{data.img}</span>
                          </div>
                          <h2>{data.title}</h2>
                          <p>{data.para}</p>
                          <button className="btn learnmore_btn" onClick={() => clickToggleLoginPopup(true)}>Learn More </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Row>
              <LoginPopup show={show} ref={childRef} />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default ReasonsChoose;
